const translations = {
  "users.UserName": "მომხმარებლის სახელი",
  "users.Email": "ელ. ფოსტა",
  "users.MustChangePassword": "პაროლი შესაცვლელია",
  "users.IsActive": "აქტიური",
  "users.AddUser": "მომხმარებლის დამატება",
  "users.EditUser": "მომხმარებლის რედაქტირება",
  "users.UserExists": "მომხმარებელი უკვე არსებობს",
  "users.Roles": "უფლებათა ჯგუფი",

  "pay-page-phone-text": "კოდი გამოიგზავნება ნომერზე, რომელიც სრულდება ციფრებით: <d></d> თუ არ სარგებლობ აღნიშნული ნომრით, გთხოვ <a><nw>შეცვალე ნომერი დისტანციურად</nw></a>",
  "get-sms-code-again": "SMS კოდის ხელახლა მიღება",
  "payment-can-be-done-after-policy-activation": `გადახდის შესრულება შესაძლებელია პოლისის გააქტიურების თარიღიდან (<nw><date></date></nw>)`,
  "pay-phone-text-1": "კოდი გამოიგზავნება ნომერზე, რომელიც სრულდება ციფრებით: ",
  "pay-phone-text-2": "თუ არ სარგებლობ აღნიშნული ნომრით, გთხოვ ",
  "pay-phone-text-3": "შეცვალე ნომერი დისტანციურად ",
  "payment-date-new": "გადახდის თარიღი",

  "enter-personal-number": "შეიყვანე შენი პირადი ნომერი",
  "enter-pin-code": "შეიყვანეთ მიღებული 4-ნიშნა კოდი",
  "pin": "პირადი ნომერი",
  "get-code": "კოდის მიღება",
  
  "agreementForRegister": "წინამდებარე დასტურით თანხმობას აცხადებთ, რომ იმედი L-მა შექმნას თქვენი მომხმარებელი მზღვეველის ელექტრონულ პორტალზე, სადაზღვევო პოლისისა და მომსახურების მიღების მიზნით"
};

export default translations;
